import React, {
  useEffect,
  useMemo,
  useRef,
  useState,
} from "react";

import "./ChatPage.css";


const API_BASE =
  process.env.REACT_APP_API_BASE_URL ||
  "http://51.20.2.237:5500";


/* ============================================================
   SirTEAM Logo
   ============================================================ */

const DRIVE_FILE_ID =
  "1AHcsR2nyeF4RM-Tvnzxqm3JllFuEhF7C";


const LOGO_CANDIDATES = [

  `https://drive.google.com/uc?export=view&id=${DRIVE_FILE_ID}`,

  `https://lh3.googleusercontent.com/d/${DRIVE_FILE_ID}=w128-h128-n`,

  `https://drive.google.com/thumbnail?id=${DRIVE_FILE_ID}&sz=w128-h128`,

  `https://drive.google.com/uc?export=download&id=${DRIVE_FILE_ID}`,

];


const INITIAL_SUGGESTIONS = [

  "써팀은 어떤 협업툴인가요?",

  "고객 문의 메일을 여러 명이 함께 관리할 수 있나요?",

  "메일에서 바로 할 일을 만들 수 있나요?",

];


export default function ChatPage() {

  /* ============================================================
     입력값
     ============================================================ */

  const [input, setInput] =
    useState("");


  /* ============================================================
     대화 메시지
     ============================================================ */

  const [messages, setMessages] =
    useState([

      {
        id: "m-0",

        sender: "bot",

        text:
          "안녕하세요! 써팀(SirTEAM)의 기능과 활용 방법에 대해 궁금한 점을 물어보세요.",
      },

    ]);


  /* ============================================================
     답변 생성 상태
     ============================================================ */

  const [
    isSending,
    setIsSending,
  ] = useState(false);


  /* ============================================================
     추천 질문 생성 상태
     ============================================================ */

  const [
    isSuggesting,
    setIsSuggesting,
  ] = useState(false);


  const [
    toast,
    setToast,
  ] = useState("");


  const [
    showScrollFab,
    setShowScrollFab,
  ] = useState(false);


  /* ============================================================
     현재 화면에 표시되는 추천 질문
     ============================================================ */

  const [
    suggestions,
    setSuggestions,
  ] = useState(
    INITIAL_SUGGESTIONS
  );


  /* ============================================================
     지금까지 화면에 노출된 추천 질문
     ============================================================ */

  const [
    shownSuggestions,
    setShownSuggestions,
  ] = useState(
    INITIAL_SUGGESTIONS
  );


  const [
    logoIdx,
    setLogoIdx,
  ] = useState(0);


  const logoSrc =
    LOGO_CANDIDATES[logoIdx];


  const endRef =
    useRef(null);


  const listRef =
    useRef(null);


  const textRef =
    useRef(null);


  const controllerRef =
    useRef(null);


  /* ============================================================
     메시지 생성 시 하단으로 이동
     ============================================================ */

  useEffect(() => {

    endRef.current
      ?.scrollIntoView({

        behavior:
          "smooth",

        block:
          "end",

      });

  }, [
    messages,
    isSending,
    isSuggesting,
    suggestions,
  ]);


  /* ============================================================
     스크롤 위치 확인
     ============================================================ */

  useEffect(() => {

    const el =
      listRef.current;


    if (!el) {

      return;

    }


    const onScroll =
      () => {

        const nearBottom =

          el.scrollHeight -

            el.scrollTop -

            el.clientHeight

          < 180;


        setShowScrollFab(
          !nearBottom
        );

      };


    el.addEventListener(

      "scroll",

      onScroll

    );


    return () => {

      el.removeEventListener(

        "scroll",

        onScroll

      );

    };

  }, []);


  /* ============================================================
     전송 가능 여부
     ============================================================ */

  const canSend =
    useMemo(

      () =>

        input.trim().length > 0 &&

        !isSending,

      [
        input,
        isSending,
      ]

    );


  /* ============================================================
     Toast
     ============================================================ */

  const showError =
    (
      msg
    ) => {

      setToast(
        msg
      );


      setTimeout(

        () => {

          setToast("");

        },

        3500

      );

    };


  /* ============================================================
     Textarea Auto Size
     ============================================================ */

  const autoSize =
    () => {

      const t =
        textRef.current;


      if (!t) {

        return;

      }


      t.style.height =
        "auto";


      t.style.height =

        Math.min(

          t.scrollHeight,

          220

        )

        + "px";

    };


  /* ============================================================
     Logo fallback
     ============================================================ */

  const handleLogoError =
    () => {

      setLogoIdx(

        (i) =>

          i + 1 <
          LOGO_CANDIDATES.length

            ? i + 1

            : i

      );

    };


  /* ============================================================
     질문 Normalize

     띄어쓰기 / 문장부호 차이를 제거해서
     동일 질문 중복 방지
     ============================================================ */

  function normalizeQuestion(
    value
  ) {

    return String(
      value || ""
    )

      .toLowerCase()

      .replace(

        /[\s?.!,~"'’“”():;·-]+/g,

        ""

      );

  }


  /* ============================================================
     추천 질문 중복 제거
     ============================================================ */

  function uniqueTop3(
    arr,
    excluded = []
  ) {

    const excludedSet =
      new Set(

        excluded

          .map(
            normalizeQuestion
          )

          .filter(
            Boolean
          )

      );


    const seen =
      new Set();


    const pick =
      [];


    for (
      const s of arr || []
    ) {

      const t =
        String(
          s || ""
        ).trim();


      const key =
        normalizeQuestion(
          t
        );


      if (
        !t ||
        !key ||
        seen.has(key) ||
        excludedSet.has(key)
      ) {

        continue;

      }


      seen.add(
        key
      );


      pick.push(
        t
      );


      if (
        pick.length >= 3
      ) {

        break;

      }

    }


    return pick;

  }


  /* ============================================================
     후속 질문 생성

     Backend 우선
     실패하면 localSuggest fallback
     ============================================================ */

  async function updateSuggestions(
    lastBotText,
    history
  ) {

    /* --------------------------------------------------------
       추천 질문 생성 시작
       -------------------------------------------------------- */

    setIsSuggesting(
      true
    );


    try {

      const lastUser =

        [...history]

          .reverse()

          .find(
            (m) =>
              m.sender ===
              "user"
          );


      const askedQuestions =

        history

          .filter(
            (m) =>
              m.sender ===
              "user"
          )

          .map(
            (m) =>
              m.text
          );


      const controller =
        new AbortController();


      const timeout =
        setTimeout(

          () =>
            controller.abort(),

          5000

        );


      try {

        const res =
          await fetch(

            `${API_BASE}/suggestFollowups`,

            {

              method:
                "POST",

              headers: {

                "Content-Type":
                  "application/json",

              },

              signal:
                controller.signal,

              body:
                JSON.stringify({

                  lastUserText:
                    lastUser?.text || "",

                  lastBotText,

                  history:
                    history.slice(-12),

                  excludedQuestions: [

                    ...shownSuggestions,

                    ...suggestions,

                    ...askedQuestions,

                  ],

                  n: 3,

                  locale:
                    "ko",

                  domain:
                    "sirteam",

                }),

            }

          );


        clearTimeout(
          timeout
        );


        if (
          !res.ok
        ) {

          throw new Error(
            `HTTP ${res.status}`
          );

        }


        const data =
          await res.json();


        const raw =

          Array.isArray(
            data
          )

            ? data

            : data?.suggestions;


        if (
          Array.isArray(raw) &&
          raw.length
        ) {

          const next =
            uniqueTop3(

              raw,

              [

                ...shownSuggestions,

                ...askedQuestions,

              ]

            );


          if (
            next.length
          ) {

            setSuggestions(
              next
            );


            setShownSuggestions(

              (prev) =>

                Array.from(

                  new Set([

                    ...prev,

                    ...next,

                  ])

                )

            );


            return;

          }

        }

      }

      catch (e) {

        clearTimeout(
          timeout
        );


        console.warn(

          "후속 질문 API 실패, 로컬 추천으로 대체합니다.",

          e

        );

      }


      /* ========================================================
         Backend 추천 실패 시
         Frontend fallback
         ======================================================== */

      const local =
        uniqueTop3(

          localSuggest(

            lastBotText,

            history

          ),

          [

            ...shownSuggestions,

            ...askedQuestions,

          ]

        );


      setSuggestions(
        local
      );


      setShownSuggestions(

        (prev) =>

          Array.from(

            new Set([

              ...prev,

              ...local,

            ])

          )

      );

    }

    finally {

      /* --------------------------------------------------------
         추천 질문 생성 완료
         -------------------------------------------------------- */

      setIsSuggesting(
        false
      );

    }

  }


  /* ============================================================
     SirTEAM 문맥 기반 로컬 추천
     ============================================================ */

  function localSuggest(
    lastBotText = "",
    history = []
  ) {

    const t =

      (
        lastBotText ||
        ""
      )

        .toLowerCase();


    const base = [

      "써팀은 어떤 협업툴인가요?",

      "기존 기업메일과 어떤 차이가 있나요?",

      "공유메일함은 어떻게 사용할 수 있나요?",

      "고객 문의 메일을 여러 명이 함께 관리할 수 있나요?",

      "메일에서 바로 할 일을 만들 수 있나요?",

      "메일과 프로젝트를 함께 관리할 수 있나요?",

      "담당자가 바뀌어도 기존 업무 기록을 확인할 수 있나요?",

      "써팀에서는 어떤 AI 기능을 사용할 수 있나요?",

      "메신저와 캘린더도 함께 사용할 수 있나요?",

      "전자결재 기능도 제공하나요?",

      "기존 메일 데이터를 이전할 수 있나요?",

      "써팀 도입 비용은 어떻게 확인할 수 있나요?",

      "써팀 도입에 대해 상담받고 싶어요.",

    ];


    const byKeyword =
      [];


    /* 가격 */

    if (
      /비용|가격|견적|요금|라이선스|무료|할인/.test(
        t
      )
    ) {

      byKeyword.push(

        "Free 요금제와 유료 요금제는 어떤 차이가 있나요?",

        "현재 적용 가능한 프로모션도 있나요?",

        "써팀의 요금은 어떤 기준으로 결정되나요?"

      );

    }


    /* 도입 */

    if (
      /도입|구축|시작|전환|설치/.test(
        t
      )
    ) {

      byKeyword.push(

        "써팀 도입은 어떤 절차로 진행되나요?",

        "기존 기업메일을 사용하면서 써팀을 도입할 수 있나요?",

        "기존 메일 데이터도 이전할 수 있나요?"

      );

    }


    /* 연동 */

    if (
      /연동|api|통합|integration|시스템/.test(
        t
      )
    ) {

      byKeyword.push(

        "기존 시스템과 연동할 수 있나요?",

        "API 연동 범위는 어떻게 확인할 수 있나요?",

        "Google Calendar와도 연동할 수 있나요?"

      );

    }


    /* 기업메일 */

    if (
      /메일|이메일|email|기업메일/.test(
        t
      )
    ) {

      byKeyword.push(

        "메일에서 바로 할 일을 만들 수 있나요?",

        "공유메일함은 어떻게 사용할 수 있나요?",

        "기존 기업메일과 써팀은 어떤 차이가 있나요?"

      );

    }


    /* 공유메일 */

    if (
      /공유메일|공용메일|대표메일|고객메일|문의메일|support|sales|info/.test(
        t
      )
    ) {

      byKeyword.push(

        "대표메일을 여러 명이 함께 관리할 수 있나요?",

        "고객 문의 메일의 담당자를 나눠서 관리할 수 있나요?",

        "담당자가 바뀌면 이전 고객 메일도 확인할 수 있나요?"

      );

    }


    /* 고객 문의 */

    if (
      /고객|문의|cs|상담|요청/.test(
        t
      )
    ) {

      byKeyword.push(

        "고객 요청을 메일에서 업무로 연결할 수 있나요?",

        "담당자가 바뀌어도 고객 대응 기록을 확인할 수 있나요?",

        "고객 문의가 많을 때 누락되지 않도록 관리할 수 있나요?"

      );

    }


    /* 업무 */

    if (
      /할일|할 일|업무|프로젝트|담당자/.test(
        t
      )
    ) {

      byKeyword.push(

        "메일에서 생성한 업무는 어떻게 관리하나요?",

        "프로젝트와 고객메일을 함께 관리할 수 있나요?",

        "업무 담당자와 마감일을 지정할 수 있나요?"

      );

    }


    /* 인수인계 */

    if (
      /인수인계|퇴사|담당자 변경|부서 이동|휴가/.test(
        t
      )
    ) {

      byKeyword.push(

        "담당자가 바뀌면 기존 메일과 업무 기록은 어떻게 확인하나요?",

        "고객 업무를 인수인계할 때 써팀을 어떻게 활용할 수 있나요?",

        "공유메일함을 사용하면 인수인계가 어떻게 달라지나요?"

      );

    }


    /* AI */

    if (
      /ai|인공지능|요약|브리핑|작성|검색/.test(
        t
      )
    ) {

      byKeyword.push(

        "써팀에서는 어떤 AI 기능을 사용할 수 있나요?",

        "AI 업무 브리핑은 어떤 정보를 보여주나요?",

        "AI가 메일 답변 초안도 작성해주나요?"

      );

    }


    /* 협업 */

    if (
      /메신저|캘린더|위키|드라이브|전자결재|협업/.test(
        t
      )
    ) {

      byKeyword.push(

        "써팀에서 사용할 수 있는 협업 기능을 알려주세요.",

        "메일과 다른 협업 기능은 어떻게 연결되나요?",

        "전자결재 기능도 사용할 수 있나요?"

      );

    }


    /* 보안 */

    if (
      /보안|인증|개인정보|접근|권한|스팸/.test(
        t
      )
    ) {

      byKeyword.push(

        "써팀의 메일 보안 기능을 알려주세요.",

        "SPF, DKIM, DMARC도 지원하나요?",

        "메일 DLP나 아카이빙도 사용할 수 있나요?"

      );

    }


    /* 제품 비교 */

    if (
      /아웃룩|outlook|구글|google|gmail|슬랙|slack|지라|jira|두레이|dooray|네이버웍스|하이웍스|플로우|잔디/.test(
        t
      )
    ) {

      byKeyword.push(

        "써팀이 다른 협업툴과 가장 다른 점은 무엇인가요?",

        "메일 중심으로 협업한다는 것은 어떤 의미인가요?",

        "우리 회사에는 어떤 도구가 더 잘 맞을까요?"

      );

    }


    const lastUser =

      [...history]

        .reverse()

        .find(
          (m) =>
            m.sender ===
            "user"
        )

        ?.text

      || "";


    if (
      lastUser &&
      lastUser.length < 80
    ) {

      byKeyword.push(

        "이 기능을 실제 업무에서는 어떻게 사용할 수 있나요?"

      );

    }


    const pool = [

      ...byKeyword,

      ...base,

    ];


    /* ========================================================
       순서 랜덤화
       ======================================================== */

    for (
      let i =
        pool.length - 1;

      i > 0;

      i--
    ) {

      const j =
        Math.floor(

          Math.random() *
          (i + 1)

        );


      [
        pool[i],
        pool[j],
      ]

      =

      [
        pool[j],
        pool[i],
      ];

    }


    return pool;

  }


  /* ============================================================
     메시지 전송
     ============================================================ */

  const sendMessage =
    async (
      rawText
    ) => {

      const text =

        (
          rawText ||
          ""
        )

          .trim();


      if (
        !text ||
        isSending
      ) {

        return;

      }


      /* ========================================================
         새로운 질문이 시작되면
         기존 추천 질문 즉시 제거
         ======================================================== */

      setSuggestions([]);


      /* ========================================================
         혹시 기존 요청이 남아있다면 취소
         ======================================================== */

      controllerRef.current
        ?.abort();


      const userMsg = {

        id:
          `m-${Date.now()}-u`,

        sender:
          "user",

        text,

      };


      setMessages(

        (prev) => [

          ...prev,

          userMsg,

        ]

      );


      setInput(
        ""
      );


      setIsSending(
        true
      );


      autoSize();


      try {

        const controller =
          new AbortController();


        controllerRef.current =
          controller;


        /* ======================================================
           1. 답변 요청
           ====================================================== */

        const res =
          await fetch(

            `${API_BASE}/searchChat`,

            {

              method:
                "POST",

              headers: {

                "Content-Type":
                  "application/json",

              },

              body:
                JSON.stringify({

                  inputText:
                    text,

                }),

              signal:
                controller.signal,

            }

          );


        if (
          !res.ok
        ) {

          throw new Error(
            `HTTP ${res.status}`
          );

        }


        const ct =

          res.headers.get(
            "content-type"
          )

          || "";


        let botText =
          "";


        if (
          ct.includes(
            "application/json"
          )
        ) {

          const data =
            await res.json();


          botText =

            typeof data ===
            "string"

              ? data

              : data.answer

                || data.text

                || JSON.stringify(
                  data
                );

        }

        else {

          botText =
            await res.text();

        }


        if (
          !botText ||
          botText.trim() === ""
        ) {

          botText =
            "답변을 불러오지 못했습니다. 잠시 후 다시 질문해 주세요.";

        }


        const botMsg = {

          id:
            `m-${Date.now()}-b`,

          sender:
            "bot",

          text:
            botText,

        };


        const nextHistory = [

          ...messages,

          userMsg,

          botMsg,

        ];


        /* ======================================================
           2. 답변 화면에 표시
           ====================================================== */

        setMessages(

          (prev) => [

            ...prev,

            botMsg,

          ]

        );


        /* ======================================================
           답변 생성 완료

           "답변을 확인하고 있어요…" 종료
           ====================================================== */

        setIsSending(
          false
        );


        /* ======================================================
           3. 후속 질문 생성

           updateSuggestions 안에서
           isSuggesting = true
           ====================================================== */

        await updateSuggestions(

          botText,

          nextHistory

        );

      }

      catch (e) {

        if (
          e.name !==
          "AbortError"
        ) {

          const errMsg = {

            id:
              `m-${Date.now()}-e`,

            sender:
              "bot",

            text:
              "답변을 불러오는 중 문제가 발생했습니다. 잠시 후 다시 시도해 주세요.",

          };


          setMessages(

            (prev) => [

              ...prev,

              errMsg,

            ]

          );


          showError(

            "네트워크 오류 또는 서버 오류가 발생했습니다."

          );

        }

      }

      finally {

        /* ======================================================
           에러가 나더라도 답변 생성 상태 종료
           ====================================================== */

        setIsSending(
          false
        );

      }

    };


  /* ============================================================
     전송 버튼
     ============================================================ */

  const handleSend =
    () => {

      sendMessage(
        input
      );

    };


  /* ============================================================
     Keyboard
     ============================================================ */

  const handleKeyDown =
    (
      e
    ) => {

      if (
        e.key ===
          "Enter" &&

        !e.shiftKey
      ) {

        e.preventDefault();


        handleSend();

      }

    };


  /* ============================================================
     추천 질문 클릭
     클릭 즉시 질문 전송
     ============================================================ */

  const ctaHandlers =
    (
      text
    ) => ({

      onClick:
        () =>
          sendMessage(
            text
          ),

    });


  /* ============================================================
     Scroll Bottom
     ============================================================ */

  const scrollToBottom =
    () => {

      endRef.current
        ?.scrollIntoView({

          behavior:
            "smooth",

          block:
            "end",

        });

    };


  /* ============================================================
     다른 질문 보기
     ============================================================ */

  const refreshSuggestions =
    () => {

      if (
        isSending ||
        isSuggesting
      ) {

        return;

      }


      const lastBot =

        [...messages]

          .reverse()

          .find(
            (m) =>
              m.sender ===
              "bot"
          )

          ?.text

        || "";


      const fresh =
        localSuggest(

          lastBot,

          messages

        );


      const askedQuestions =

        messages

          .filter(
            (m) =>
              m.sender ===
              "user"
          )

          .map(
            (m) =>
              m.text
          );


      const next =
        uniqueTop3(

          fresh,

          [

            ...shownSuggestions,

            ...askedQuestions,

          ]

        );


      setSuggestions(
        next
      );


      setShownSuggestions(

        (prev) =>

          Array.from(

            new Set([

              ...prev,

              ...next,

            ])

          )

      );

    };


  /* ============================================================
     UI
     ============================================================ */

  return (

    <div className="sirteam-root">


      {/* ======================================================
          Header
          ====================================================== */}

      <header className="sirteam-header">

        <div className="sirteam-header-inner">

          <div className="sirteam-brand">

            <div
              className="sirteam-logo"
              aria-hidden="true"
            >

              {logoSrc ? (

                <img
                  src={logoSrc}
                  alt=""
                  className="sirteam-logo-img"
                  decoding="async"
                  referrerPolicy="no-referrer"
                  onError={
                    handleLogoError
                  }
                />

              ) : (

                <span className="sirteam-logo-fallback">

                  S

                </span>

              )}

            </div>


            <div className="sirteam-brand-copy">

              <h1 className="sirteam-title">

                써팀

              </h1>


              <span className="sirteam-subtitle">

                SirTEAM AI Assistant

              </span>

            </div>

          </div>


          <div className="sirteam-badge">

            Beta

          </div>

        </div>

      </header>


      {/* ======================================================
          Conversation
          ====================================================== */}

      <main
        className="sirteam-window"
        ref={
          listRef
        }
        role="log"
        aria-live="polite"
      >

        {messages.map(

          (m) => (

            <MessageBubble
              key={
                m.id
              }
              sender={
                m.sender
              }
              text={
                m.text
              }
            />

          )

        )}


        {/* ====================================================
            답변 생성 중
            ==================================================== */}

        {isSending && (

          <TypingIndicator
            text="답변을 확인하고 있어요…"
          />

        )}


        {/* ====================================================
            답변은 완료됐고
            추천 질문 생성 중
            ==================================================== */}

        {!isSending &&
          isSuggesting && (

            <TypingIndicator
              text="추천 질문을 확인하고 있어요…"
            />

          )}


        {/* ====================================================
            추천 질문 생성 완료 후 표시
            ==================================================== */}

        <SuggestedPills
          visible={
            !isSending &&
            !isSuggesting &&
            suggestions.length > 0
          }
          items={
            suggestions
          }
          ctaHandlers={
            ctaHandlers
          }
          onRefresh={
            refreshSuggestions
          }
        />


        <div
          ref={
            endRef
          }
        />

      </main>


      {/* ======================================================
          Scroll FAB
          ====================================================== */}

      {showScrollFab && (

        <button
          className="sirteam-scroll-fab"
          onClick={
            scrollToBottom
          }
          aria-label="맨 아래로"
        >

          ↓

        </button>

      )}


      {/* ======================================================
          Input
          ====================================================== */}

      <footer className="sirteam-input-wrap">

        <div className="sirteam-input-card">

          <label
            htmlFor="chat-input"
            className="sirteam-sr-only"
          >

            메시지 입력

          </label>


          <textarea
            id="chat-input"
            ref={
              textRef
            }
            className="sirteam-textarea"
            placeholder="써팀에 대해 궁금한 점을 입력하세요."
            value={
              input
            }

            onChange={(e) => {

              setInput(
                e.target.value
              );


              autoSize();

            }}

            onKeyDown={
              handleKeyDown
            }

            onInput={
              autoSize
            }

            disabled={
              isSending
            }
          />


          <div className="sirteam-actions">

            <span className="sirteam-hint">

              {
                isSending

                  ? "써팀이 답변을 확인하고 있어요…"

                  : isSuggesting

                    ? "추천 질문을 확인하고 있어요…"

                    : "Enter로 전송 · Shift+Enter로 줄바꿈"
              }

            </span>


            <button
              type="button"
              className="sirteam-send"
              onClick={
                handleSend
              }
              disabled={
                !canSend
              }
              aria-label="메시지 전송"
            >

              {isSending

                ? <Spinner />

                : <SendIcon />

              }


              <span>

                {isSending

                  ? "전송 중"

                  : "전송"

                }

              </span>

            </button>

          </div>

        </div>


        <p className="sirteam-footnote">

          답변은 제공된 써팀 관련 자료를 기준으로 안내됩니다.

        </p>

      </footer>


      {/* ======================================================
          Toast
          ====================================================== */}

      {toast && (

        <div
          className="sirteam-toast"
          role="status"
        >

          {toast}

        </div>

      )}

    </div>

  );

}


/* ============================================================
   URL Rendering
   ============================================================ */

function renderTextWithLinks(
  text
) {

  const tokens =
    String(
      text || ""
    ).split(" ");


  const nodes =
    [];


  for (
    let i = 0;
    i < tokens.length;
    i++
  ) {

    const t =
      tokens[i];


    const isUrl =

      t.startsWith(
        "http://"
      )

      ||

      t.startsWith(
        "https://"
      );


    nodes.push(

      isUrl ? (

        <a
          key={
            `u-${i}`
          }
          href={
            t
          }
          target="_blank"
          rel="noopener noreferrer"
          className="sirteam-link"
        >

          {t}

        </a>

      ) : (

        t

      )

    );


    if (
      i !==
      tokens.length - 1
    ) {

      nodes.push(
        " "
      );

    }

  }


  return nodes;

}


/* ============================================================
   Message Bubble
   ============================================================ */

function MessageBubble({
  sender,
  text,
}) {

  const isUser =
    sender ===
    "user";


  const time =
    new Date()
      .toLocaleTimeString(

        [],

        {

          hour:
            "2-digit",

          minute:
            "2-digit",

        }

      );


  return (

    <div

      className={

        "sirteam-bubble-row " +

        (
          isUser
            ? "right"
            : "left"
        )

      }

    >

      {!isUser && (

        <div className="sirteam-avatar">

          S

        </div>

      )}


      <div

        className={

          "sirteam-bubble " +

          (
            isUser
              ? "user"
              : "bot"
          )

        }

      >

        <div className="sirteam-bubble-text">

          {renderTextWithLinks(
            text
          )}

        </div>


        <div className="sirteam-bubble-meta">

          <button
            className="sirteam-copy-btn"

            onClick={() =>

              navigator.clipboard
                .writeText(

                  String(
                    text || ""
                  )

                )

            }

            title="복사"
          >

            ⧉

          </button>


          <span className="sirteam-time">

            {time}

          </span>

        </div>

      </div>


      {isUser && (

        <div className="sirteam-avatar user">

          You

        </div>

      )}

    </div>

  );

}


/* ============================================================
   Typing Indicator

   text 값을 받아서
   답변 / 추천 질문 상태를 구분
   ============================================================ */

function TypingIndicator({
  text =
    "답변을 확인하고 있어요…",
}) {

  return (

    <div className="sirteam-typing">

      <span className="sirteam-dot" />

      <span className="sirteam-dot" />

      <span className="sirteam-dot" />


      <span className="sirteam-typing-text">

        {text}

      </span>

    </div>

  );

}


/* ============================================================
   Spinner
   ============================================================ */

function Spinner() {

  return (

    <svg
      className="sirteam-spinner"
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      aria-hidden
    >

      <circle
        className="track"
        cx="12"
        cy="12"
        r="10"
        strokeWidth="4"
      />


      <path
        className="head"
        d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z"
      />

    </svg>

  );

}


/* ============================================================
   Send Icon
   ============================================================ */

function SendIcon() {

  return (

    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="currentColor"
      className="sirteam-send-icon"
      aria-hidden
    >

      <path
        d="M2.01 21L23 12 2.01 3 2 10l15 2-15 2z"
      />

    </svg>

  );

}


/* ============================================================
   Suggested Questions
   ============================================================ */

function SuggestedPills({
  visible,
  items = [],
  ctaHandlers,
  onRefresh,
}) {

  if (
    !visible ||
    !items.length
  ) {

    return null;

  }


  return (

    <div
      className="sirteam-cta-inline"
      aria-label="추천 질문"
    >

      {items.map(

        (
          q,
          i
        ) => (

          <button
            key={
              `sugg-${i}`
            }
            className="sirteam-cta-pill"
            title="클릭해서 바로 질문"
            {...ctaHandlers(q)}
          >

            {q}

          </button>

        )

      )}


      <button
        className="sirteam-cta-pill sirteam-cta-ghost"
        onClick={
          onRefresh
        }
        title="추천 질문 새로고침"
      >

        다른 질문 보기 ↻

      </button>

    </div>

  );

}